/**
 * Make sticky column scrollable within the page
 */
class StickyColumn {

  /**
   * Constructor
   * @param {HTMLElement} element element to bind to
   */
  constructor( element ) {
    this._element = element;
    this._parent = element.parentNode;

    this._scrollDirection = 'down';
    this._lastScrollYValue = window.scrollY;
    this._elementBoundingClientRect = element.getBoundingClientRect();

    this._parent.style.position = 'relative';

    this._stickyMargin = 8;

    window.addEventListener('scroll', () => {
      this._scrollEvents();
    });
  }

  /**
   * Handle sticky column events
   */
  _scrollEvents() {
    // Do not execute this code in mobile widths
    if (window.innerWidth > 1024) {

      if (this._element.offsetHeight <= window.innerHeight) {
        // Set element to be a basic sticky element if it fits in the view
        this._element.style.position = 'sticky';
        this._element.style.top = this._stickyMargin + 'px';
      } else if (window.scrollY <= this._parent.offsetTop) {
        this._resetElement();
      } else if (window.scrollY + window.innerHeight >= this._parent.offsetTop + this._parent.offsetHeight) {
        this._setElementBottom();
      } else if (window.scrollY > this._lastScrollYValue) {
        // Scrolling down
        if (window.innerHeight + this._stickyMargin >= this._element.getBoundingClientRect().top + this._element.offsetHeight) {
          this._grabElementBottom();
        } else if (this._element.style.position === 'fixed') {
          this._freezeElement();
        }
      } else if (window.scrollY < this._lastScrollYValue) {
        // Scrolling up
        if (this._element.getBoundingClientRect().top >= 0) {
          this._grabElementTop();
        } else if (this._element.style.position === 'fixed') {
          this._freezeElement();
        }
      }

      // Set last scrollY value
      this._lastScrollYValue = window.scrollY;
    }
  }

  /**
   * Set element to window bottom
   */
  _grabElementBottom() {
    this._element.style.top = window.innerHeight - this._element.offsetHeight - this._stickyMargin + 'px';
    this._element.style.position = 'fixed';
  }

  /**
   * Set element to window top
   */
  _grabElementTop() {
    this._element.style.top = this._stickyMargin + 'px';
    this._element.style.position = 'fixed';
  }

  /**
   * Set element to absolute position
   */
  _freezeElement() {
    this._element.style.top = window.scrollY - this._parent.offsetTop + this._element.getBoundingClientRect().top + 'px';
    this._element.style.position = 'absolute';
  }

  /**
   * Set element to parent bottom
   */
  _setElementBottom() {
    this._element.style.top = this._parent.offsetHeight - this._element.offsetHeight + 'px';
    this._element.style.position = 'absolute';
  }

  /**
   * Remove element styles so it stays at the top of the parent
   */
  _resetElement() {
    this._element.style.top = null;
    this._element.style.position = null;
  }

  /**
   * Initializes sticky columns
   */
  static init() {

    const elements = document.querySelectorAll('.sticky-column');

    elements.forEach( element => {
      new StickyColumn( element );
    });
  }
}

export default StickyColumn;
